import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Checkbox,
  Divider,
  Fade,
  FormControlLabel,
  makeStyles,
  Modal,
  Typography,
} from "@material-ui/core";
import { Mention, MentionsInput } from "react-mentions";
import defaultStyle from "./defaultStyle";
import { removeStickyNote } from "../../../addContact/contactApi";

const modalStyles = makeStyles((theme) => ({
  wrapperMain: {
    marginLeft: "10px",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: (props) => props.modalWidth,
    backgroundColor: "#F8FFC7 !important",
    borderRadius: "8px",
    boxShadow: theme.shadows[5],
    '&:focus-visible': {
      outline: "none !important",
    },
  },
  modalHeader: {
    padding: "12px",
    color: "#fff",
    backgroundColor: "#F8FFC7 !important",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    display: "flex",
    flexDirection: "column !important",
    position: "relative",
  },

  modalFooter: {
    borderEndEndRadius: "8px",
    borderEndStartRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    height: "80px",
    background: "#F8FFC7 !important",
  },
  checkBoxStyle: {
    color: "#0E1B3D",
    fontSize: "16px !important",
    fontWeight: "600",
  },
  cancelButton: {
    color: "var(--accent-color) !important",
  },
  typographyStyle: {
    height: "unset !important",
    color: "#133159",
    fontWeight: 500,
    fontSize: "15px",
    marginBottom: "20px",
    textAlign: "center",
  },
  button: {
    padding: "8px 16px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    "&:disabled": {
      backgroundColor: "#e0e0e0 !important",
      color: "#a0a0a0 !important",
      cursor: "not-allowed",
      pointerEvents: "none",
    },
  },
  closeButton: {
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #a5a5a5",
    "&:focus, &:hover": {
      backgroundColor: "#f3f4f6",
      transform: "translateY(-1px)",
      border: "1px solid #a5a5a5",
    },
  },
  confirmButton: {
    backgroundColor: "#3e50f7",
    padding: "8px 24px",
    color: "#fff",
    border: "1px solid #3e50f7",
    "&:focus, &:hover": {
      border: "1px solid #3e50f7",
      backgroundColor: "#3e50f7",
      transform: "translateY(-1px)",
    },
  },
}));
const mentionStyle = {
  backgroundColor: "#cee4e5",
};
const StickyNote = ({ modalWidth = 650, open, onClose, stickyNoteData, stickyCallbackRef  }) => {
  const [note, setNote] = useState("");
  const [isStickyNote, setIsStickyNote] = useState(false);
  const classes = modalStyles({ modalWidth });
  const headerIconSrc = `${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/location_16138494.png`;

useEffect(()=>{
  if(stickyNoteData){
    setNote(stickyNoteData.message);
  }
},[stickyNoteData])

  
  const handleSubmit = async () => {
    if(isStickyNote){
      const res = await removeStickyNote({userStickyNoteId: stickyNoteData?.id});
      if(res.success){
        setIsStickyNote(false);
        if (typeof stickyCallbackRef?.current === 'function') {
          stickyCallbackRef.current(); 
          stickyCallbackRef.current = null; 
        }
        window.showNotification("SUCCESS", res.message);
      } else {
        window.showNotification("ERROR", res.message);
      }
      onClose();
    } else {
      onClose();
    }
  
  };
  const dateTimeConversion = (date) => {
    if (window.formatDateWithoutTimezoneChange) {
      return window.formatDateWithoutTimezoneChange(date, "UTC", "MMMM D, YYYY h:mma");
    } else {
      return date;
    }
  };
  
  return (
    <div className={classes.wrapperMain}>
      <Modal
        open={open}
        onClose={onClose}
        className={classes.modal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.modalHeader}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ marginLeft: "16px" }}>
                  <Typography
                    style={{
                      height: "unset !important",
                      color: "#133159",
                      fontWeight: 600,
                    }}
                    variant='h5'
                  >
                    Sticky Note
                  </Typography>
                </div>
                <Divider style={{ width: "450px", marginLeft: "16px", marginRight: "16px" }} />
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    position: "absolute",
                    right: "-20px",
                    top: "-30px",
                    transform: "rotate(30deg)",
                  }}
                >
                  {headerIconSrc && (
                    <img
                      src={headerIconSrc}
                      alt='logo'
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#133159",
                    margin: "10px 16px",
                  }}
                >
                  <div>{stickyNoteData?.user?.full_name}</div>
                  <div>{dateTimeConversion(stickyNoteData?.created_at)}</div>
                </div>
              </div>
            </div>

            <div>
              <div className='modal-content p-0'>
                <div className='chat__bottom_wrapper update'>
                  <div className='tiny-mce'>
                    <MentionsInput
                      cols={30}
                      rows={5}
                      className='control-overflow mentionClass'
                      value={note}
                      style={defaultStyle}
                      markup='@[__display__](__id__) '
                      placeholder={''}
                      disabled={true}
                    >
                      <Mention
                        type='user'
                        trigger='@'
                        renderSuggestion={(suggestion, search, highlightedDisplay) => (
                          <div className='user'>{highlightedDisplay}</div>
                        )}
                        style={mentionStyle}
                      />
                    </MentionsInput>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.modalFooter}>
              <div style={{ marginLeft: "20px" }}>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.cancelButton}
                        size={"small"}
                        checked={isStickyNote}
                        onChange={() => setIsStickyNote(!isStickyNote)}
                      />
                    }
                    className={classes.checkBoxStyle}
                    label='Remove it as sticky note'
                  />
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginRight: "16px" }}>
                <button
                  onClick={handleSubmit}
                  disableElevation
                  // disabled={submitButtonDisabled}
                  className={`${classes.button} ${classes.confirmButton}`}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default StickyNote;
